module.exports = __webpack_public_path__ + "0c82b0019520b346cf741bf0ee9accb6.vtt";